var React = require('react');

function MailIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon","transform":"translate(-437.232 -329.414)"},[React.createElement("path",{"id":"Path_87","data-name":"Path 87","d":"M455.587,329.414h-16.6a1.756,1.756,0,0,0-1.755,1.756v10.237a1.756,1.756,0,0,0,1.755,1.756h16.6a1.757,1.757,0,0,0,1.755-1.756V331.17A1.757,1.757,0,0,0,455.587,329.414Z","fill":"#fff","key":0}),React.createElement("path",{"id":"Path_86","data-name":"Path 86","d":"M451.109,336.218l4.081-4.083a.79.79,0,0,0-1.117-1.118l-6.011,6.012a1.231,1.231,0,0,1-1.738,0l-5.818-5.818a.79.79,0,0,0-1.118,1.117h0l3.87,3.87-3.952,3.862a.791.791,0,1,0,1.069,1.166.419.419,0,0,0,.037-.036l3.963-3.872.832.832a2.813,2.813,0,0,0,3.973,0l.81-.81,4.2,3.807A.791.791,0,1,0,455.282,340l-.029-.027Z","fill":"#e24301","key":1})]));
}

MailIconInline.defaultProps = {"width":"20.11","height":"13.749","viewBox":"0 0 20.11 13.749"};

module.exports = MailIconInline;

MailIconInline.default = MailIconInline;
